import React, {Component} from 'react'
import CredentialsInput from './CredentialsInput'
import authService from '../common/services/authService'

const FormErrors = {
    INVALID_CREDENTIALS : "Invalid Credentials",
    UNKNOWN : "Unexpected error occurred. Most likely the backend is down."
};

export default class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: "",
            password: "",
            loginError: null
        }
    }

    componentWillMount() {
        this.redirectToDashboardIfApplicable();
    }

    componentWillReceiveProps() {
        this.redirectToDashboardIfApplicable();
    }

    componentWillUpdate() {
        this.redirectToDashboardIfApplicable();
    }

    redirectToDashboardIfApplicable() {
        if (authService.isLoggedIn()) {
            this.context.router.push('/dashboard');
        }
    }

    onLoginChanged = (login) => {
        this.setState( { login: login } )
    };

    onPassChanged = (pass) => {
        this.setState( { password: pass } );
    };

    onSubmit = (event) => {
        if (event) event.preventDefault();
        this.props.http.authenticate(this.state.login, this.state.password)
            .then((token) => {
                authService.login(token);
                this.setState( { loginError: null } );
                this.context.router.push('/dashboard');
            }).catch((error) => {
                const areInvalidCredentials = error.response && error.response.status === 401;
                const errorMessage = areInvalidCredentials ? FormErrors.INVALID_CREDENTIALS  : FormErrors.UNKNOWN;
                this.setState( { loginError: errorMessage } );
            });
    };

    render() {
        return (
            <div className="container">
                 <div className="row">
                     <div className="col-md-4 col-md-offset-4">
                         <form role="form">
                             <h3>Please sign in</h3>
                             <CredentialsInput id="login" type="text" onChanged={this.onLoginChanged}  placeholder="Login"/>
                             <CredentialsInput id="password" type="password" onChanged={this.onPassChanged} placeholder="Password"/>
                             <p id="login-error" hidden={!this.state.loginError} className="text-danger">{this.state.loginError}</p>
                             <input id="login-submit" className={"btn btn-primary btn-block"} onClick={this.onSubmit} type="submit" value="Sign in"/>
                         </form>
                    </div>
                </div>
            </div>
        )
    }
}

Login.contextTypes = {
    router: React.PropTypes.object
};

Login.propTypes = {
    http: React.PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/auth/Login.js